import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ROUTING_INFORMACION_PAGO_PENSION } from '../shared/common/constants/url.constant';
import { InformacionPagoPensionHomeComponent } from "./pages/informacion-pago-pension-home/informacion-pago-pension-home.component";
import { ValidateSurveyGuard } from "@shared/common/guards/validate-survey.guard";

const INFORMACION_PAGO_PENSION_ROUTES: Routes = [
  {
    path: "",
    redirectTo: ROUTING_INFORMACION_PAGO_PENSION.INFORMACION_PAGO_PENSION_HOME,
    pathMatch: "full",
  },
  {
    path: ROUTING_INFORMACION_PAGO_PENSION.INFORMACION_PAGO_PENSION_HOME,
    canDeactivate: [ValidateSurveyGuard],
    component: InformacionPagoPensionHomeComponent,    
  },
];

@NgModule({
  imports: [RouterModule.forChild(INFORMACION_PAGO_PENSION_ROUTES)],
  exports: [RouterModule],
})
export class InformacionPagoPensionRoutingModule {}
